import React from 'react';
import { Icon } from 'semantic-ui-react';
import GlassmorphismTheme from '../../../../styles/glassmorphism';
import { ConversationMetrics } from '../types/dashboard.types';

interface ConversionFunnelProps {
  metrics: ConversationMetrics;
}

const ConversionFunnel: React.FC<ConversionFunnelProps> = ({ metrics }) => {
  const stages = [
    {
      label: 'Enviadas (Últimos 7 dias)',
      value: metrics.templatesSent,
      icon: 'send',
      color: '#3498db'
    },
    {
      label: 'Entregues (Últimos 7 dias)',
      value: Math.round(metrics.templatesSent * (metrics.deliveryRate / 100)),
      icon: 'check',
      color: '#27ae60'
    }
  ];

  return (
    <div
      style={{
        ...GlassmorphismTheme.components.glassCard,
        background: 'linear-gradient(135deg, rgba(155, 89, 182, 0.1), rgba(52, 152, 219, 0.1))',
        border: GlassmorphismTheme.borders.glassAccent,
        padding: GlassmorphismTheme.spacing.sm,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <h4 style={{
        margin: `0 0 ${GlassmorphismTheme.spacing.sm} 0`,
        color: '#2c3e50',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '1rem'
      }}>
        <Icon name="sitemap" style={{ color: '#667eea' }} />
        Funil de Conversão
      </h4>

      {/* STAGES GRID */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: GlassmorphismTheme.spacing.sm,
        flex: 1,
        alignContent: 'center'
      }}>
        {stages.map((stage) => (
          <div key={stage.label} style={{
            background: 'rgba(255, 255, 255, 0.1)',
            borderRadius: GlassmorphismTheme.borderRadius.md,
            padding: '20px 16px',
            border: `1px solid ${stage.color}40`,
            textAlign: 'center',
            transition: GlassmorphismTheme.transitions.normal
          }}>
            {/* ICON & LABEL */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '4px',
              marginBottom: '4px'
            }}>
              <Icon
                name={stage.icon as any}
                size="large"
                style={{ color: stage.color }}
              />
              <strong style={{ 
                color: '#2c3e50',
                fontSize: '0.8rem',
                textAlign: 'center',
                lineHeight: 1.2
              }}>
                {stage.label}
              </strong>
            </div>

            {/* VALUE */}
            <div style={{
              fontSize: '1.2rem',
              fontWeight: 700,
              color: stage.color,
              marginBottom: '8px'
            }}>
              {stage.value.toLocaleString('pt-BR')}
            </div>

            {/* PERCENTAGE */}
            <div style={{
              fontSize: '0.85rem',
              color: '#7f8c8d',
              fontWeight: 500
            }}>
              {stage.label === 'Enviadas' ? '100%' : `${metrics.deliveryRate.toFixed(1)}%`}
            </div>
          </div>
        ))}
      </div>

      {/* SUMMARY */}
      <div style={{
        marginTop: GlassmorphismTheme.spacing.md,
        paddingTop: GlassmorphismTheme.spacing.md,
        borderTop: GlassmorphismTheme.borders.glassLight,
        textAlign: 'center'
      }}>
        <div style={{
          padding: '16px 24px',
          background: 'rgba(52, 152, 219, 0.1)',
          borderRadius: GlassmorphismTheme.borderRadius.sm,
          display: 'inline-block'
        }}>
          <small style={{ color: '#95a5a6' }}>Taxa de Entrega</small>
          <p style={{
            margin: '6px 0 0 0',
            fontWeight: 600,
            color: '#3498db',
            fontSize: '1.2rem'
          }}>
            {metrics.deliveryRate.toFixed(1)}%
          </p>
        </div>
      </div>
    </div>
  );
};

export default ConversionFunnel;